import {
  BOOKSHELF_REQUEST,
  BOOKSHELF_GET_LIST,
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_CREATE,
  BOOKSHELF_UPDATE,
  BOOKSHELF_DELETE,
  BOOKSHELF_SUCCESS,
  BOOKSHELF_FAILURE,
  BOOKSHELF_BOOK_REQUEST,
  BOOKSHELF_BOOK_GET,
  BOOKSHELF_BOOK_GET_LIST,
  BOOKSHELF_BOOK_SUCCESS,
  BOOKSHELF_BOOK_FAILURE,
  BOOKSHELF_BOOK_MOVE_BOOKS,
  BOOKSHELF_BOOK_COUNT,
  BOOKSHELF_BOOK_FILTER,
  BOOKSHELF_MOVE,
  BOOKSHELF_BOOK_DELETE_BOOKS
} from '@/store/types'

import axios from '@/store/axios'

/* TODO: @stan, 
  Refactor keyMapper values as global constant and 
  methods for converting from and to
*/
const keyMapper = {
  bookshelfId: 'id',
  bookshelfNm: 'name',
  bookNm: 'title',
  thumbUrl: 'img',
  noteYn: 'hasNote',
  idx: 'id',
  catgryNm: 'title'
}

// Set current selected library as default library
const state = {
  current: { id: '' },
  books: null,
  // staticBookShelves: [],
  isLoading: false,
  isBookLoading: false,
  error: null,
  bookshelves: [],
  meta: {},
  bookMeta: {},
  currentBook: null
}

const getters = {
  getBookshelves: (state) => state.bookshelves,
  getStaticBookshelves: (state) => state.staticBookShelves,
  getBookshelfCount: (state) => state.bookshelves.length,
  getCurrentBookshelf: (state) => state.current,
  getCurrentBookshelfBooks: (state) => state.books,
  // getCurrentBookshelfBooks: (state) => state.testBooks,
  isBookshelfLoading: (state) => state.isLoading,
  getBookshelfTotalBookCount: (state) =>
    state.bookMeta.totalCount || (state.books ? state.books.length : 0),
  isBookshelfBookLoading: (state) => state.isBookLoading,
  getBookshelfCurrentBook: (state) => state.currentBook
}

const actions = {
  [BOOKSHELF_CREATE]: ({ commit }, { name }) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_REQUEST)

      axios
        .post(`/myLibrary/bookshelf/create`, {
          params: { bookshelfNm: name }
        })
        .then((resp) => {
          commit(BOOKSHELF_SUCCESS, { bookshelf: resp.data.result })
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_FAILURE, err)
          reject(err)
        })
    })
  },
  [BOOKSHELF_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_REQUEST)

      axios
        .get(`/myLibrary/bookshelf/list`)
        .then((resp) => {
          commit(BOOKSHELF_SUCCESS, {
            bookshelves: resp.data.result.bookshelfList
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_FAILURE, err)
          // alert('로그아웃되었습니다.\n다시 로그인 해 주세요')
          alert(
            '[다른 기기에서 접속되어 로그아웃되었습니다. 이용을 원하시면 다시 로그인 해주세요.]'
          )
          localStorage.removeItem('token')
          location.href = '/'
          reject(err)
        })
    })
  },
  /* 
    TODO: @stan, Currently, dummy backend returns 406 error. 
    Need to make sure this works going forward.
  */
  [BOOKSHELF_UPDATE]: ({ commit }, bookshelf) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_REQUEST)

      axios
        .put(`/myLibrary/bookshelf/${bookshelf.id}`, {
          params: {
            bookshelfNm: bookshelf.name
          }
        })
        .then((resp) => {
          bookshelf.bookshelfNm = bookshelf.name
          commit(BOOKSHELF_SUCCESS, { bookshelf })
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_FAILURE, err)
          reject(err)
        })
    })
  },
  [BOOKSHELF_DELETE]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_REQUEST)

      axios
        .delete(`/myLibrary/bookshelf/${id}`)
        .then((resp) => {
          commit(BOOKSHELF_SUCCESS, { deleted: id })
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_FAILURE, err)
          reject(err)
        })
    })
  },

  [BOOKSHELF_BOOK_GET_LIST]: (
    { commit, state },
    { page = 1, sort = 'PD', searchTxt = '', filterList = [], bookshelfId } = {}
  ) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_BOOK_REQUEST)

      // /myLibrary/bookshelf/books/list
      // /myLibrary/purchase/list
      const shelfId = bookshelfId || state.current.id
      axios
        .get(
          `/myLibrary/bookshelf/books/list?pageNo=${page}&pageRow=30&bookshelfId=${shelfId}&searchTp=${sort}&searchTxt=${searchTxt}&filterList=${filterList}`
        )
        .then((resp) => {
          commit(BOOKSHELF_BOOK_SUCCESS, {
            books: resp.data.result.myBookList,
            meta: {
              totalCount: resp.data.page
                ? resp.data.page.totalCount
                : resp.data.result.myBookList.length,
              lastLoaded: resp.data.respTime
            }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_BOOK_FAILURE, err, true)
          // alert('로그아웃되었습니다.\n다시 로그인 해 주세요')
          alert(
            '[다른 기기에서 접속되어 로그아웃되었습니다. 이용을 원하시면 다시 로그인 해주세요.]'
          )
          localStorage.removeItem('token')
          location.href = '/'
          reject(err)
        })
    })
  },
  [BOOKSHELF_BOOK_GET]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_BOOK_REQUEST)
      // orderId 미사용. payload 형식은 유지.
      // const orderId = payload.orderId ? `?orderId=${payload.orderId}` : ''
      axios
        .get(`/myLibrary/book/info/${payload.id}`)
        .then((resp) => {
          //get 값인 동시에 promise return 값으로도 사용.
          const book = resp.data.result?.bookInfo || []
          commit(BOOKSHELF_BOOK_SUCCESS, {
            book: book
          })
          resolve(book)
        })
        .catch((err) => {
          commit(BOOKSHELF_BOOK_FAILURE, err, true)
          alert(
            '[다른 기기에서 접속되어 로그아웃되었습니다. 이용을 원하시면 다시 로그인 해주세요.]'
          )
          localStorage.removeItem('token')
          location.href = '/'
          reject(err)
        })
    })
  },
  [BOOKSHELF_BOOK_MOVE_BOOKS]: (
    { commit, state },
    { bookshelfId, to, books }
  ) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_BOOK_REQUEST)

      const shelfId = bookshelfId || state.current.id
      axios
        .post(`/myLibrary/bookshelf/content/move`, {
          params: {
            bookshelfId: shelfId,
            targetId: to,
            bookList: books
          }
        })
        .then((resp) => {
          const newBooks = state.books.filter((b) => !books.includes(b.id))
          commit(BOOKSHELF_BOOK_SUCCESS, { books: newBooks })
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_BOOK_REQUEST, err)
          reject(err)
        })
    })
  },
  [BOOKSHELF_BOOK_DELETE_BOOKS]: (commit, { bookshelfId, bookCode }) => {
    // commit(BOOKSHELF_BOOK_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .delete(`/myLibrary/bookshelf/${bookshelfId}/${bookCode}`)
        .then((resp) => {
          //commit(BOOKSHELF_BOOK_SUCCESS)
          const deleted = resp.data.result.deleted
          resolve(deleted)
        })
        .catch((err) => {
          //commit(BOOKSHELF_BOOK_FAILURE)
          reject(err)
        })
    })
  },
  [BOOKSHELF_BOOK_COUNT]: (commit, { bookshelfId, searchTxt = '' }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/myLibrary/bookshelf/books/count?bookshelfId=${bookshelfId}&searchTxt=${searchTxt}`
        )
        .then((resp) => {
          const count = resp.data.result.total
          resolve(count)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [BOOKSHELF_BOOK_FILTER]: (commit, { bookshelfId }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/myLibrary/bookshelf/bookTypes?bookshelfId=${bookshelfId}`)
        .then((resp) => {
          const filter = resp.data.result.flags
          resolve(filter)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [BOOKSHELF_MOVE]: ({ commit }, reorderData) => {
    return new Promise((resolve, reject) => {
      commit(BOOKSHELF_BOOK_REQUEST)

      axios
        .post(`/myLibrary/bookshelf/reorder`, reorderData)
        .then((resp) => {
          // 성공 시 필요한 처리
          commit(BOOKSHELF_BOOK_SUCCESS, resp.data)
          resolve(resp)
        })
        .catch((err) => {
          commit(BOOKSHELF_BOOK_REQUEST, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [BOOKSHELF_REQUEST]: (state) => {
    state.isLoading = true
  },
  [BOOKSHELF_SUCCESS]: (state, { bookshelf, bookshelves, deleted }) => {
    state.isLoading = false

    if (bookshelves) {
      // let base = []
      // let present = []
      // let gift = []

      bookshelves.map((bs) => {
        Object.keys(bs).map((key) => {
          if (keyMapper[key]) {
            bs[keyMapper[key]] = bs[key]
          }
        })
      })
      // bookshelves.forEach((e) => {
      //   console.log(e, this)
      //   switch (e.bookshelfTp) {
      //     // DBS, 사용자생성책장=UBS, 선물책장=GFT, 무료책장=PFF, 쿠폰책장=CPN, 증정본책장=PRS
      //     case 'GFT':
      //       gift.push(e)
      //       break
      //     case 'PRS':
      //       present.push(e)
      //       break
      //     default:
      //       base.push(e)
      //       break
      //   }
      // })

      // state.staticBookShelves = [...gift, ...present]
      state.bookshelves = bookshelves
    }

    if (bookshelf) {
      Object.keys(bookshelf).map((key) => {
        if (keyMapper[key]) {
          bookshelf[keyMapper[key]] = bookshelf[key]
        }
      })
      // Newly created
      if (!state.bookshelves.find((bs) => bs.id === bookshelf.id)) {
        state.bookshelves = [...state.bookshelves, bookshelf]
      } else {
        state.bookshelves = state.bookshelves.map((bs) => {
          if (bs.id === bookshelf.id) return bookshelf
          return bs
        })
      }
    }

    if (deleted) {
      state.bookshelves = [
        ...state.bookshelves.filter((bs) => bs.id !== deleted)
      ]
    }
  },
  [BOOKSHELF_FAILURE]: (state, err) => {
    state.isLoading = false
    if (err) state.error = err
  },
  [BOOKSHELF_SET_CURRENT]: (state, id) => {
    state.current = state.bookshelves.find((bs) => bs.id === id) || { id: '' }
  },
  [BOOKSHELF_BOOK_REQUEST]: (state) => {
    state.isBookLoading = true
  },
  [BOOKSHELF_BOOK_SUCCESS]: (state, { books, book, meta = {} }) => {
    state.isBookLoading = false
    if (books) {
      books.map((book) => {
        Object.keys(book).map((key) => {
          if (keyMapper[key]) {
            book[keyMapper[key]] = book[key]
          }
        })
      })
      state.books = books
    }

    if (book) {
      Object.keys(book).map((key) => {
        if (keyMapper[key]) {
          book[keyMapper[key]] = book[key]
        }
      })
      state.currentBook = book
    }

    if (Object.keys(meta).length > 0) {
      state.bookMeta = {
        ...state.bookMeta,
        ...meta
      }
    }
  },
  [BOOKSHELF_BOOK_FAILURE]: (state, err) => {
    state.isBookLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
